import React from 'react';
import './index.scss';
import { IFooterButItemInfo } from '../../interface';
import { Button } from '@umu/umu-design';
interface IProps {
  list: IFooterButItemInfo[];
  onClick: (item: IFooterButItemInfo) => void;
}
const CalendarDaysFooter = (props: IProps) => {
  const { list = [], onClick } = props;
  return (
    <div className='calendar-days-footer-info'>
      {list.map((item: IFooterButItemInfo, index: number) => {
        return <Button key={`footer-${item.key}-${index}`} className={`${item.className || ''} footer-btn`} type={item.type} onClick={() => item.onClick ? item.onClick() : onClick(item)}>{item.label}</Button>
      }
      )}
    </div>
  );
}

export {
  CalendarDaysFooter
};
